import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText } from '@insurancemenu/imenu-components-lib';
import { ReplicatedInfoDelegate } from 'store/modules/dynamic-form/replicatedInfoDelegate';
import {
  AuthorizedAgentFormFields,
  DDARAuthorizedAgent,
} from 'store/modules/dynamic-form/DDAR/authorizedAgentsDelegate';
import ReplicatedInfo from '../../ReplicatedInfoV2';

interface Props {
  delegate: ReplicatedInfoDelegate<DDARAuthorizedAgent, AuthorizedAgentFormFields> | null;
}

const AgentFormFields: React.FC = observer(() => {
  return (
    <>
      <IMInputText label="First Name" name="firstName" maxLength={50} />
      <IMInputText label="Last Name" name="lastName" maxLength={50} />
      <IMInputText label="Email" name="email" maxLength={50} />
      <IMInputText
        label="Broker Portal User Name"
        name="userName"
        maxLength={50}
        description="If already have access"
      />
    </>
  );
});

const DDARAuthorizedAgents: React.FC<Props> = observer(({ delegate }) => {
  return delegate ? (
    <ReplicatedInfo
      delegate={delegate}
      modalItemTitle="Authorized Agent"
      addButtonLabel="Add"
      columns={[
        {
          title: 'Name',
          width: '13rem',
          getValue: (info) => `${info.firstName} ${info.lastName}`,
        },
        { title: 'Email', width: '18rem', getValue: (info) => info.email ?? '' },
        {
          title: 'User Name',
          width: '13rem',
          getValue: (info) => info.userName ?? '',
        },
      ]}
      addItemFormFields={<AgentFormFields />}
      editItemFormFields={<AgentFormFields />}
    />
  ) : null;
});

export default DDARAuthorizedAgents;
